<template>
	<div class="sy-ch-main container-fluid text-center">
		<table v-on:keyup.enter = "login" align="center" style="text-align:left;margin:auto;" class="container400">
			<tbody>
				<tr>
					<td>

						<div class="form_control mt3">
							<label for="input-email">Email</label>
							<input type = "email" id="input-email" placeholder = "example@email.com" v-model.trim = " addForm['Email']">
							<div class="error mt1">
								{{errorMsg['Email']}}
							</div>
						</div>
					</td>
				</tr>
				<tr>
					<td>
						<div class="form_control">
							<label for="input-password">Password</label>
							<input type = "password" id="input-password" class="password" placeholder = "******" v-model.trim = " addForm['Password']">
							<div class="error mt1">
								{{errorMsg['Password']}}
							</div>
							<div class="show-password text-right mt1">Show</div>
						</div>
						<div class="error">
							{{errorMsgFB}}
						</div>
					</td>
				</tr>
				<tr>
					<td>
						<div class="form_control">
							<div class="pb1 text-right">
								<router-link :to = "{path: '/' + $route.params.businessID + '/forgot-password'}">
									Forgot password
								</router-link>
							</div>
							<div class="btn" @click = "login">Login</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>	
</template>

<script>
import firebase from "firebase";
var md5 = require('md5');
var uuid = require('uuid/v5');
var itemTemplate;
export default {
	//==============================================//
	//												//
	//					DATA						//
	//												//
	//==============================================//
	data(){
		itemTemplate = [{"Name":"Email","checkFun":"email","children":[],"defaultValue":"","inputType":"email","manyView":true,"max":"","min":"","placeholder":"example@email.com","singleView":true,"type":"Email"},{"Name":"Password","checkFun":"text","children":[],"defaultValue":"","inputType":"password","manyView":true,"max":"","min":"","placeholder":"Password","singleView":true,"type":"Password"}];
		return{
			// FORM
			addForm: myInput.init(itemTemplate).output,
			errorMsg: myInput.init(itemTemplate).errorMsg,
			// NAV VARIABLES
			editing: false,
			loaded: false,

			// PLACEHOLDER
			errorMsgFB: ""
		}
	},
	mounted(){
		setTimeout(()=>{
			customJS.runAll();
		},30);
		if (myFB.auth.currentUser){
			// this.$router.push("/");
		}
		$(function(){
			$('.show-password').click(function(){
				$(this).toggleClass('active');
				if($(this).hasClass('active')){
					$('input.password').attr('type','text');
					$(this).html('Hide')
				}else{
					$('input.password').attr('type','password');
					$(this).html('Show')
				}
			});
		});
	},
	//==============================================//
	//												//
	//					METHODS						//
	//												//
	//==============================================//
	methods:{
		//------------------------------ FORMAT ------------------------------//
		formatDate(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDate(input, mode);
		},
		formatDateTime(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDateTime(input, mode, {sequence: "hh:mm"});
		},
		formatPrice(input, prefix){
			var prefix = prefix || "";
			return myPrice.display(input, prefix)
		},
		//------------------------------ EMAIL ------------------------------//
		login(){
			var response;
			var allowAdd = true;
			var checkFun = itemTemplate, addForm = myCopier.copy(this.addForm);
			response = myInput.checkMain(addForm, checkFun);
			this.errorMsg = response.errorMsg;
			if (response.error){
				allowAdd = false;
			}
			if (allowAdd){
				myFB.auth.signInWithEmailAndPassword(addForm["Email"], addForm["Password"]).then(user => {
					console.log("logged in")
					this.$router.push("/" + this.$route.params.businessID + "/orders")
				}).catch(err =>{
					this.errorMsgFB = err.message;
					console.log(err.message);
				})
			}
		},
		//------------------------------ GOOGLE ------------------------------//
		async googleLogin(){
			var provider = new firebase.auth.GoogleAuthProvider();
			myNotify.loading();
			await myFB.auth.signInWithRedirect(provider).then( async result =>{
				myNotify.loadStop();
				let currentUser = result.user
				var uid = currentUser.uid;
				if (result.additionalUserInfo.isNewUser){
					this.$router.push("/" + this.$route.params.businessID + "/orders")
				}
				else{
					this.$router.push("/" + this.$route.params.businessID + "/orders")
				}
			}).catch(e=>{
				myNotify.loadStop();
				this.errorMsgFB	 = e.message;
			})
		},
		//------------------------------ FACEBOOK ------------------------------//
		async facebookLogin(){
			var provider = new firebase.auth.FacebookAuthProvider();
			myNotify.loading();
			await myFB.auth.signInWithRedirect(provider).then( async result =>{
				let currentUser = result.user
				var uid = currentUser.uid;
				myNotify.loadStop();
				if (result.additionalUserInfo.isNewUser){
					this.$router.push("/" + this.$route.params.businessID + "/")
				}
				else{
					this.$router.push("/" + this.$route.params.businessID + "/")
				}
			}).catch(e=>{
				myNotify.loadStop();
				this.errorMsgFB	 = e.message;
			})
		},
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Profile/Login.vue